module.exports = __webpack_public_path__ + "static/michael-e96f89f531bd6acb66c225957fec2a25.jpg";